module.exports = __webpack_public_path__ + "img/cake-16.dd6f1a84.svg";